import React from 'react';
import { useTrial } from '../contexts/TrialContext';
import '../styles/TrialBanner.css';

const TrialBanner = () => {
  // DEVELOPMENT: Banner completely hidden
  // Will be re-enabled when game is complete and pricing is set
  return null;
  
  /* Original code - uncomment when ready for production
  const { isTrialActive, timeRemainingFormatted, hoursRemaining, trialStatus } = useTrial();

  // Don't show banner if:
  // 1. Trial is not active
  // 2. User is premium (has purchased)
  // 3. User has unlimited access
  if (!isTrialActive) return null;
  if (trialStatus?.is_premium) return null;
  if (trialStatus?.has_unlimited_access) return null;

  const getUrgencyClass = () => {
    if (hoursRemaining < 6) return 'urgent';
    if (hoursRemaining < 24) return 'warning';
    return 'normal';
  };

  return (
    <div className={`trial-banner ${getUrgencyClass()}`}>
      <div className="trial-content">
        <span className="trial-icon">⏳</span>
        <span className="trial-text">
          Trial ends in: <strong>{timeRemainingFormatted}</strong>
        </span>
        <span className="trial-message">
          Explore all variants before time runs out!
        </span>
      </div>
    </div>
  );
  */
};

export default TrialBanner;
